import { UNIT_OF_MEASUREMENT_CATEGORIES } from "@artisancode/api-types";
import { z } from "zod";

export const uomSchema = z.object({
  name: z.string().min(1, "Nama satuan wajib diisi"),
  symbol: z.string().min(1, "Simbol wajib diisi"),
  category: z.enum(UNIT_OF_MEASUREMENT_CATEGORIES),
  workspaceId: z.string().optional(),
});

export type UomFormValues = z.infer<typeof uomSchema>;

export const defaultUomValues: UomFormValues = {
  name: "",
  symbol: "",
  category: "other",
  workspaceId: "",
};
